<div class="new_leave_modal">
  <div class="new_leave_modal-toolbar" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="16px">
    <div class="new_leave_modal-title" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <mat-icon class="fa-lg primary" fontSet="fa" fontIcon="fa-plus"></mat-icon>
      <div class="new_leave_modal-title_content" fxLayout="column">
        <!-- titulo -->
        <h4 *ngIf="!holiday.id">{{ 'settings.addDialogHoliday.newHolidayTitle' | transloco }}</h4>
        <h4 *ngIf="holiday.id">{{ 'settings.addDialogHoliday.editHolidayTitle' | transloco }}</h4>
      </div>
    </div>
    <!-- cerrar modal -->
    <button mat-icon-button mat-dialog-close>
      <mat-icon class="fa-lg" fontSet="fa" fontIcon="fa-times" fxLayout="row" fxLayoutAlign="center center">
      </mat-icon>
    </button>
  </div>
    <form class="new_leave_modal-form" [formGroup]="menuFormHoliday" fxLayout="column" fxLayoutAlign="start center" fxLayoutGap="10px" style="width: 520px !important;padding-bottom: 20px;">
      <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
        <mat-label>{{ 'settings.addDialogHoliday.yearLbl' | transloco }}</mat-label>
        <input matInput [value]="holidayYear" readonly />
      </mat-form-field>
    <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
      <mat-label>{{ 'settings.addDialogHoliday.holidayTypeLbl' | transloco }}</mat-label>
      <mat-select formControlName="TipoFeriado" [(value)]="holiday.holidayType">
        <mat-option *ngFor="let feriado of tiposDeFeriados" [value]="feriado">{{feriado}}</mat-option>
        <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
        <mat-option *ngIf="holiday.id != undefined" value="{{holiday.holidayType}}">{{holiday.holidayType}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
      <mat-label>{{ 'settings.addDialogHoliday.descriptionLbl' | transloco }}</mat-label>
      <input matInput maxlength="100" [placeholder]="'settings.addDialogHoliday.descriptionLbl' | transloco"  formControlName="description"/>
      <mat-label *ngIf="error !==''">{{ 'settings.addDialogHoliday.invalidFieldLbl' | transloco }}</mat-label>
    </mat-form-field>

    <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
      <mat-label>{{ 'settings.addDialogHoliday.dateLbl' | transloco }}</mat-label>
      <input readonly matInput  (dateChange)="setEffectiveDate($event)" [min]="MinDate" [max]="MaxDate" [matDatepicker]="fechaInicia"
        formControlName="DateFeriado" [matDatepickerFilter]="yearFilter">
      <mat-datepicker-toggle matIconSuffix [for]="fechaInicia">
        <mat-datepicker #fechaInicia></mat-datepicker>
      </mat-datepicker-toggle>
    </mat-form-field>

    <mat-form-field class="new_leave_modal-field" appearance="fill" fxFill>
      <mat-label>{{ 'settings.addDialogHoliday.executionDateLbl' | transloco }}</mat-label>
      <input readonly matInput [min]="HastaMinDate" [max]="MaxDate" [matDatepicker]="fechaFin"
        formControlName="EffectiveDate">
      <mat-datepicker-toggle matIconSuffix [for]="fechaFin">
        <mat-datepicker #fechaFin></mat-datepicker>
      </mat-datepicker-toggle>
    </mat-form-field>

    <div class="custom-slider-container">
      <mat-slide-toggle formControlName="state">{{ 'settings.addDialogHoliday.activeLbl' | transloco }}</mat-slide-toggle>
    </div>

    <div class="new_leave_modal-actions"  fxLayout="row-reverse" fxLayout="end center" fxLayoutGap="16px">
      <button mat-raised-button color="primary" (click)="save()" [disabled]="disabledbutton() || loading">{{ 'common.acceptBtn' | transloco }}</button>
      <button mat-button mat-dialog-close>{{ 'common.cancelBtn' | transloco }}</button>
    </div>
  </form>
</div>
